import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#4C4DEE",
  "stroke-width": "1.382",
  d: "M12.212 1.19c5.943 0 10.81 5.036 10.81 11.31s-4.867 11.31-10.81 11.31c-5.942 0-10.81-5.036-10.81-11.31S6.27 1.19 12.213 1.19Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M10.304 16.5v-1.428h1.656v-4.404h-1.428V9.576a6 6 0 0 0 1.056-.288q.432-.168.84-.408h1.296v6.192h1.428V16.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }